/**
 * API Base URL Configuration
 *
 * Base URLs for API and WebSocket connections.
 * Set via environment variables for different deployment environments.
 */

const DEFAULT_API_BASE = import.meta.env.PROD
  ? 'https://signa-api.ulrich-8db.workers.dev'
  : 'http://localhost:8788';
const DEFAULT_WS_BASE = import.meta.env.PROD
  ? 'wss://signa-api.ulrich-8db.workers.dev'
  : 'ws://localhost:8788';

export const API_BASE = import.meta.env.VITE_API_URL ?? DEFAULT_API_BASE;
export const WS_BASE = import.meta.env.VITE_WS_URL ?? DEFAULT_WS_BASE;

// Todo AI endpoints
export const TODO_AI_BASE = `${API_BASE}/todo-ai`;

// Todo API endpoints

export const TODO_API = {
  list: () => `${API_BASE}/todos`,
  create: () => `${API_BASE}/todos`,
  update: (id: string) => `${API_BASE}/todos/${id}`,
  delete: (id: string) => `${API_BASE}/todos/${id}`,
  toggleComplete: (id: string) => `${API_BASE}/todos/${id}/toggle-complete`,
  reorder: () => `${API_BASE}/todos/reorder`,
  bulkComplete: () => `${API_BASE}/todos/bulk-complete`,
  createProject: () => `${API_BASE}/todos/projects`,
  updateProject: (id: string) => `${API_BASE}/todos/projects/${id}`,
  deleteProject: (id: string) => `${API_BASE}/todos/projects/${id}`,
  createSection: () => `${API_BASE}/todos/sections`,
  updateSection: (id: string) => `${API_BASE}/todos/sections/${id}`,
  deleteSection: (id: string) => `${API_BASE}/todos/sections/${id}`,
} as const;

// Notes API endpoints

export const NOTE_API = {
  list: () => `${API_BASE}/notes`,
  get: (id: string) => `${API_BASE}/notes/${id}`,
  create: () => `${API_BASE}/notes`,
  update: (id: string) => `${API_BASE}/notes/${id}`,
  delete: (id: string) => `${API_BASE}/notes/${id}`,
  backlinks: (id: string) => `${API_BASE}/notes/${id}/backlinks`,
  daily: (date: string) => `${API_BASE}/notes/daily/${date}`,
} as const;

// Memory API endpoints

export const MEMORY_API = {
  search: () => `${API_BASE}/memory`,
  context: () => `${API_BASE}/memory/context`,
  store: () => `${API_BASE}/memory`,
} as const;
